import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { PaymentType } from 'src/app/shared/utils/payments';

type Result = {
	useUpdatedName: boolean;
	properties: {
		paymentFirstName?: string;
		paymentLastName?: string;
	};
};

export function useUpdateTrackingEventsWithGuestData(): (paymentType: PaymentType) => Result {
	const {
		data: { guestUserData },
	} = usePromotePageData();
	const [{ prefilledWithGuestData, firstName, lastName }] = usePromotePageState();

	return function updatedName(paymentType) {
		if (paymentType !== 'creditCard') {
			return { useUpdatedName: false, properties: {} };
		}
		const useUpdatedName = !!(
			prefilledWithGuestData &&
			(firstName !== guestUserData?.firstName || lastName !== guestUserData.lastName)
		);

		return {
			useUpdatedName,
			properties: {
				paymentFirstName: firstName,
				paymentLastName: lastName,
			},
		};
	};
}
